import { render } from "./Home.vue?vue&type=template&id=12dd913f&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "@/assets/css/main.css?vue&type=style&index=0&id=12dd913f&scoped=true&lang=css"
import "@/assets/css/layout.css?vue&type=style&index=1&id=12dd913f&scoped=true&lang=css"

import exportComponent from "C:\\Users\\info\\Documents\\ownersite.vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12dd913f"]])

export default __exports__